import { instance } from '@/libs/api/instance'

/**
 * Mark notification as read
 *
 * @param id
 * @return {Promise<AxiosResponse<any>>}
 */
export const markAsRead = async (id) => {
  return instance.patch(`/v2/notification/${id}`)
}
